import { eventEmitter, type ShowInputDialogPayload } from '@/lib/eventEmitter.ts';

export const showInputDialogAsync = (
    options: Omit<ShowInputDialogPayload, 'submitCallback' | 'cancelCallback'>,
): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        eventEmitter.emit('showInputDialog', {
            title: options.title,
            description: options.description,
            label: options.label,
            defaultValue: options.defaultValue,
            submitText: options.submitText,
            cancelText: options.cancelText,
            submitCallback: (value: string) => resolve(value),
            cancelCallback: () => reject(),
        });
    });
};
